export const ROLES_ON_DELETE_REQUESTED = 'ROLES_ON_DELETE_REQUESTED';
export const ROLES_ON_DELETE_SUCCEEDED = 'ROLES_ON_DELETE_SUCCEEDED';
export const ROLES_ON_DELETE_FAILED = 'ROLES_ON_DELETE_FAILED';

export const ROLES_ON_GET_ALL_REQUESTED = 'ROLES_ON_GET_ALL_REQUESTED';
export const ROLES_ON_GET_ALL_SUCCEEDED = 'ROLES_ON_GET_ALL_SUCCEEDED';
export const ROLES_ON_GET_ALL_FAILED = 'ROLES_ON_GET_ALL_FAILED';

export const ROLES_ON_GET_FORM_REQUESTED = 'ROLES_ON_GET_FORM_REQUESTED';
export const ROLES_ON_GET_FORM_SUCCEEDED = 'ROLES_ON_GET_FORM_SUCCEEDED';
export const ROLES_ON_GET_FORM_FAILED = 'ROLES_ON_GET_FORM_FAILED';

export const ROLES_ON_GET_ONE_REQUESTED = 'ROLES_ON_GET_ONE_REQUESTED';
export const ROLES_ON_GET_ONE_SUCCEEDED = 'ROLES_ON_GET_ONE_SUCCEEDED';
export const ROLES_ON_GET_ONE_FAILED = 'ROLES_ON_GET_ONE_FAILED';

export const ROLES_ON_SAVE_REQUESTED = 'ROLES_ON_SAVE_REQUESTED';
export const ROLES_ON_SAVE_SUCCEEDED = 'ROLES_ON_SAVE_SUCCEEDED';
export const ROLES_ON_SAVE_FAILED = 'ROLES_ON_SAVE_FAILED';
